/// <amd-module name="Feed/Legacy/Components/DescriptionGridCell" />
import * as React from "react";

import { TooltipHost, TooltipOverflowMode } from "VSSUI/Tooltip";

import { Package } from "Feed/Common/Contracts/Feed";

export interface IDescriptionGridCellProps {
    item: Package;
}

export class DescriptionGridCell extends React.PureComponent<IDescriptionGridCellProps> {
    public render(): JSX.Element {
        return (
            <div className="package-description-grid-cell">
                {this.props.item.versions[0].packageDescription ? (
                    <TooltipHost
                        content={this.props.item.versions[0].packageDescription}
                        overflowMode={TooltipOverflowMode.Parent}
                    >
                        <span>{this.props.item.versions[0].packageDescription}</span>
                    </TooltipHost>
                ) : null}
            </div>
        );
    }
}
